<template>
  <div class="companies">
    <MobileTable
      v-model:selection="store.state.company.selectedCompanies"
      :label="$route.name"
      :columns="company.columns"
      :data="store.state.company.companies"
    />
    <DesktopTable
      v-model:selection="store.state.company.selectedCompanies"
      :label="$route.name"
      :columns="company.columns"
      :data="store.state.company.companies"
    />
    <Actions :items="company.actions" />
  </div>
</template>

<script>
import { useRouter, useRoute } from "vue-router";
import Actions from "../../components/shared/Actions.vue";
import MobileTable from "../../widgets/tables/MobileTable";
import DesktopTable from "../../widgets/tables/DesktopTable";
import { onBeforeMount, reactive } from "vue";
import store from "../../store";
import { openMode, actions } from "../../constants";

export default {
  components: { MobileTable, DesktopTable, Actions },

  setup() {
    const router = useRouter();
    const route = useRoute();
    const onCreate = () => {
      store.commit("setOpenMode", openMode.CREATE);
      router.push("/administradoras/nuevo");
    };
    const onModify = () => {
      if (store.state.company.selectedCompanies.length !== 1) {
        alert("Debe seleccionar un registro!");
      } else {
        store.commit("setOpenMode", openMode.MODIFY);
        router.push("/administradoras/modificar");
      }
    };
    const onRemove = async () => {
      if (store.state.company.selectedCompanies.length !== 1) {
        alert("Debe seleccionar un registro!");
      } else {
        store.commit("setLoading", true);
        const response = await store.dispatch(
          actions.companyActions.delete,
          store.state.company.selectedCompanies[0].id
        );
        if (response.ok) {
          store.commit("setSelectedCompanies", []);
          await store.dispatch(actions.companyActions.findAll);
          store.commit("setLoading", false);
        } else {
          store.commit("setLoading", false);
          store.state.toast.add({
            severity: "error",
            summary: "",
            detail: response.message,
            life: 5000,
          });
        }
      }
    };

    const company = reactive({
      columns: [
        {
          field: "name",
          header: "Nombre",
          sort: true,
        },
        {
          field: "identity",
          header: "Rut / CI",
          sort: true,
        },
        {
          field: "address",
          header: "Dirección",
          sort: true,
        },
        {
          field: "country",
          header: "País",
          sort: true,
        },
        {
          field: "state",
          header: "Departamento",
          sort: true,
        },
        {
          field: "city",
          header: "Ciudad",
          sort: true,
        },
        {
          field: "email",
          header: "Email",
        },
        {
          field: "phone",
          header: "Teléfono",
        },
        {
          field: "plan",
          header: "Plan",
          sort: true,
        },
      ],
      actions: [
        {
          name: "Nuevo",
          action: onCreate,
          hidden: router
            .getRoutes()
            .find((route) => route.path === "/administradoras/nuevo"),
        },
        {
          name: "Modificar",
          action: onModify,
          hidden: router
            .getRoutes()
            .find((route) => route.path === "/administradoras/modificar"),
        },
        {
          name: "Eliminar",
          action: onRemove,
          hidden: router
            .getRoutes()
            .find((route) => route.path === "/administradoras/modificar"),
        },
      ],
    });

    onBeforeMount(async () => {
      store.commit("setLoading", true);
      store.commit("setSelectedCompanies", []);
      const finded = store.state.general.breadcrumbs.find(
        (item) => item.to === route.path
      );
      if (!finded)
        store.commit("addBreadcrumb", { label: route.name, to: route.path });
      await store.dispatch(actions.companyActions.findAll, -1);
      store.commit("setLoading", false);
    });

    return { store, company };
  },
};
</script>

<style scoped></style>
